import React from 'react';
import { Pressable } from 'react-native';

import type { AvailableIconName } from '@/assets/icons';
import { SvgIcon, Text } from '@/components/ui';
import { createStyles, useScaling } from '@/hooks';
import { colors, guardianColors } from '@/theme/colors';

const SECURITY_USER_ICON_COLOR = '#64748B';

type ActionRowProps = {
  icon: AvailableIconName;
  label: string;
  onPress: () => void;
};

export function ActionRow({ icon, label, onPress }: ActionRowProps) {
  const { scale } = useScaling();
  const styles = useStyles();

  return (
    <Pressable
      accessibilityRole="button"
      onPress={onPress}
      style={({ pressed }) => [styles.cardRow, pressed ? styles.pressed : null]}>
      <SvgIcon
        name={icon}
        size={scale(24)}
        color={icon === 'IcSecurityUser' ? SECURITY_USER_ICON_COLOR : guardianColors['6']}
      />
      <Text variant="Font Guardian App/Subtitle/Subtitle 14 Semibold" style={styles.label}>
        {label}
      </Text>
      <SvgIcon name="IcChevronRight" size={scale(20)} color={guardianColors['6']} />
    </Pressable>
  );
}

const useStyles = createStyles(({ scale }) => ({
  cardRow: {
    borderRadius: scale(12),
    minHeight: scale(56),
    borderCurve: 'continuous',
    backgroundColor: colors['0'],
    flexDirection: 'row',
    alignItems: 'center',
    padding: scale(10),
    gap: scale(8),
    shadowColor: '#222B45',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.04,
    shadowRadius: scale(8),
    elevation: 1,
  },
  label: {
    flex: 1,
    color: guardianColors['10'],
  },
  pressed: {
    opacity: 0.68,
  },
}));
